<template>
    <div>
        <div class="actions" v-if="hasPermission(user,'can_access_all_internal_acts')">
            <a href="/internal-acts/items-in-internal-movement" class="btn btn-outline-primary btn-sm" target="_blank">Priekšmeti, kas atrodas iekšējā kustībā</a>
            <button class="btn btn-sm btn-primary" @click="create()">Pievienot jaunu aktu</button>
        </div>
        <table class="table table-hover">
            <thead class="bg-primary text-white">
            <tr>
                <th>Numurs</th>
                <th>Pirmā puse</th>
                <th>Otrā puse</th>
                <th>Datums</th>
                <th>Termiņš</th>
                <th>Mērķis</th>
                <th>Veids</th>
                <th class="text-center">Priekšmeti</th>
                <th class="text-center">Darbības</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="act in acts">
                <td>{{act.act_number}}</td>
                <td>{{act.first_person_firstname}} {{act.first_person_lastname}}, {{act.first_person_position}}</td>
                <td>{{act.second_person_firstname}} {{act.second_person_lastname}}, {{act.second_person_position}}</td>
                <td>{{normalDate(act.act_date)}}</td>
                <td>{{normalDate(act.due_date)}}</td>
                <td>{{act.purpose}}</td>
                <td>
                  <span class="badge badge-light" v-if="act.act_type == 'give'">Izsniegšana no krājuma</span>
                  <span class="badge badge-light" v-if="act.act_type == 'receive'">Pieņemšana krājumā</span>
                  <span class="badge badge-light" v-if="act.act_type == 'give_with_reference'">Izsniegšana no krājuma (papildus)</span>
                  <span class="badge badge-light" v-if="act.act_type == 'receive_with_reference'">Pieņemšana krājumā (papildus)</span>
                  <span class="badge badge-light" v-if="act.act_type == 'give_with_reference_extension'">Izsniegšana no krājuma (papildus)</span>
                  <span class="badge badge-light" v-if="act.act_type == 'receive_with_reference_extension'">Pieņemšana krājumā (papildus)</span>
                  <span class="badge badge-light" v-if="act.act_type == 'fact_finding'">Faksta konstatācijas akts</span>
                </td>
                <td class="text-center">{{act.items_count}}</td>
                <td class="text-right">
                    <div class="itemActions">
                        <a :href="'/internal-acts/show/'+act.id" class="action view"><span class="material-icons">visibility</span></a>
                        <div v-if="hasPermission(user,'can_access_all_internal_acts')" @click="deleteAct(act.id)" class="action delete" ><span class="material-icons">delete</span></div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-if="acts.length === 0" class="alert alert-info text-center">
            Šobrīd sistēmā Jums nav pieejams neviens akts.
        </div>
    </div>
</template>


<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
    gap: 10px;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    .action{
        cursor:pointer;
        padding:5px 15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
</style>
<script>
export default{
    props:['user'],
    mounted()
    {
        var that = this;
        axios.post('/internal-acts/get-acts').then(response =>{
            that.acts = response.data.acts;
        });
    },
    data()
    {
        return{
            loading:false,
            title:"",
            acts:[]
        }
    },
    methods:{
        hasPermission(user,permission)
        {

          return user.allpermissions.some(function(p) {
            return p.name == permission;
          });
        },
        normalDateTime(date)
        {
            if(date != null)
            {
                return moment(date).format('DD.MM.YYYY. HH:mm')
            }
            else
            {
                return null;
            }
        },
        normalDate(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY.')
            }
            else
            {
                return null;
            }
        },
        create()
        {
            var that = this;
            axios.post('/internal-acts/create',{
                title: this.title
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.loading = false;
                    that.$toast.open(response.data.message);
                    window.location.replace("/internal-acts/show/"+response.data.act.id);
                }
                else {
                    that.errors = response.data.errors;
                    that.$toast.error(response.data.message);
                }
            })
        },
        deleteAct(id) {
          var that = this;
          that.$swal.fire({
            title: 'Vai tiešām vēlaties dzēst aktu?',
            text: "Akts tiks neatgriezeniski dzēsts.",
            icon: 'error',
            showCancelButton: true,
            confirmButtonColor: '#E53935',
            cancelButtonColor: '#888787',
            confirmButtonText: 'Dzēst',
            cancelButtonText: 'Atcelt'
          }).then((result) => {
            if (result.value) {
              axios.post('/internal-acts/delete/' + id).then(response => {
                if (response.data.status == 'ok') {
                  that.acts = response.data.acts;
                  that.$toast.open(response.data.message);
                } else {
                  that.$toast.error(response.data.message);
                }
              });
            }
          });
        },
    }
}
</script>
